export default __webpack_public_path__ + "static/media/passenger.0ac3f5a3.svg";